import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function ContentList6({ data }) {
    const { contentList6ButtonText, contentList6Subtitle, contentList6PageLink, contentList6Image, contentList6Text, contentList6Title, contentList6ButtonExternalLink } = data
    return (
        <div className='csp-guide-wrap panel-space-70'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center heading-head-sec'>
                        <h2 className='heading-level-2 blue-color'>
                            {contentList6Title && parser(contentList6Title)}
                        </h2>
                        <p>
                            <strong>{contentList6Subtitle && parser(contentList6Subtitle)}</strong>
                        </p>
                    </div>
                </div>
                <div className='row csp-guide-content'>
                    <div className='col-md-6'>
                        <figure>
                            <GatsbyImage
                                image={getImage(contentList6Image?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6 principles-content'>
                        {contentList6Text && parser(contentList6Text)}
                    </div>

                    <div className='col-md-12 text-center mt-5'>
                        {contentList6ButtonExternalLink ? (
                            <a href={contentList6ButtonExternalLink} className="btn blue-btn">
                                {contentList6ButtonText}
                            </a>
                        ) : contentList6PageLink ? (
                            <Link to={contentList6PageLink.uri} className='btn blue-btn'>
                                {contentList6ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
